import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {

    getDivisionForDropdownByEstateID,
    GetGRNNumberByDateAndFactory,
    GetAllDetaisToTable,
    GetAllFactoriesByGroupID,
    GetAllWeighPointByOperationEntityID
};

async function getDivisionForDropdownByEstateID(estateID) {
    var estateArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return estateArray;
}

async function GetGRNNumberByDateAndFactory(dateID, estateID) {
    const response = await CommonGet('/api/GoodReceiveNoteWeb/GetGRNNumberByDateAndFactory', 'date=' + dateID + '&estateID=' + estateID);
    return response.data;
}

async function GetAllDetaisToTable(data) {
    var response = await CommonPost('/api/GoodReceiveNoteWeb/GetGoodRecieveNoteTable', null, data);
    return response;
}

async function GetAllFactoriesByGroupID(groupID) {
    var response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + groupID);
    var estateArray = [];
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function GetAllWeighPointByOperationEntityID(estateID) {
    var estateArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllWeighPointByOperationEntityID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return estateArray;
}
